import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';
import { selectComparisonCandidates } from '../../../slice/candidateSlice';
import { criteriaMockData } from '../../../../../shared/utils/constantData';
import { useEffect, useState } from 'react';

export default function Chart() {
  const ComparisonCandidates = useSelector(selectComparisonCandidates);

  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const hasAttributes = () => {
    const candidatesWithAttributes = ComparisonCandidates.filter((candidate) => {
      return candidate?.applicationCriteriasEvaluation?.length > 0
    })

    let Attributes = criteriaMockData.map((mcriteria) => {
      return {
        name: mcriteria?.jobCriteria?.criteriaName,
        max: 10,
        color: "black",
      }
    })

    if (candidatesWithAttributes.length > 0) {
      Attributes = candidatesWithAttributes[0].applicationCriteriasEvaluation.map((criteria) => {
        return {
          name: criteria?.jobCriteria?.criteriaName,
          max: 10,
          color: "black",
        }
      })
    }

    return Attributes
  }

  const option = {
    color: ["#F43F5EA6", "#4F46E5A6", "#057a55A6"],
    legend: {
      data:
        Array.isArray(ComparisonCandidates) && ComparisonCandidates?.length > 0
          ? [
              ...ComparisonCandidates.map(({ firstName, id }) => {
                return firstName + id
              }),
            ]
          : [0],
      show: false,
    },
    radar: {
      indicator: hasAttributes(),
      radius: windowWidth >= 425 ? "75%" : "70%",
      center: ["50%", "50%"],
      nameGap: windowWidth < 640 ? 5 : 15,
      axisName: {
        backgroundColor: "#FFFFFF",
        lineHeight:12,
        borderRadius: 6,
        fontSize: windowWidth < 640 ? 8 : 10,
        fontWeight: 400,
        padding: [5, 8],
        color: "#4B5563",
        formatter: (value :string) => {
          if (windowWidth <= 425) {
            const words = value?.split(' ');
            if (words.length > 2) {
              return `${words?.slice(0, 2).join(' ')}\n${words?.slice(2).join(' ')}`;
            }
            else{
              return value
            }
          }
          return value
        },
      },
    },
    series: [
      {
        type: "radar",
        areaStyle: {
          opacity: 0.3,
        },
        lineStyle: {
          opacity: 0.1,
        },
        data:
          Array.isArray(ComparisonCandidates) && ComparisonCandidates?.length > 0
            ? ComparisonCandidates.map((candidate) => {
                const value = candidate?.applicationCriteriasEvaluation?.map((criteria) => criteria?.score)
                return {
                  value,
                  name: candidate?.firstName + candidate?.id,
                  symbol: "circle",
                  symbolSize: 7,
                }
              })
            : [0],
      },
    ],
  }

  return (
    <div className="mt-10 mb-20">
      <ReactECharts
        option={option}
        className="w-full !h-[18rem] md:!h-[28rem]"
        opts={{ renderer: "svg" }}
        notMerge={true}
        lazyUpdate={false}
      />
    </div>
  )
}
